import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from './Navbar';
import PropertiesTab from './PropertiesTab';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Properties() {
  const navigate = useNavigate();
  const [, setRefreshKey] = useState(0);

  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/login');
  }, [navigate]);

  const handleUpdate = useCallback(async () => {
    // Trigger any consumer-driven refresh; PropertiesTab fetches its own data,
    // so we just bump a key in case parents need it later.
    try {
      const token = localStorage.getItem('token');
      await axios.get(`${API}/dashboard/summary`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {
      /* non-blocking */
    }
    setRefreshKey((k) => k + 1);
  }, []);

  return (
    <div className="app-page">
      <Navbar back={{ to: '/dashboard', label: 'Back' }} />
      <main className="app-page-main" data-testid="properties-page">
        <div className="app-page-header">
          <h1 className="app-page-title" data-testid="properties-page-title">Properties</h1>
        </div>
        <PropertiesTab onUpdate={handleUpdate} />
      </main>
    </div>
  );
}
